import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const curr = '£';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 9,
    fontFamily: 'Helvetica',
  },
  header: {
    textAlign: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 15,
    textDecoration: 'underline',
  },
  clientInfo: {
    flexDirection: 'row',
    border: '1pt solid #000',
    borderLeftWidth: 0,
  },
  clientInfoItem: {
    flexDirection: 'row',
    marginRight: 20,
  },
  clientInfoLabel: {
    fontWeight: 'bold',
    marginRight: 5,
    padding: 5,
    borderLeft: '1pt solid #000',
    borderRight: '1pt solid #000',
  },
  clientInfoValue: {
    fontWeight: 'normal',
    width: '20%',
    padding: 5,
  },
  sectionTitle: {
    fontSize: 10,
    textAlign: 'center',
    fontWeight: 'bold',
    paddingBottom: 8,
  },
  listItem: {
    flexDirection: 'row',
    marginBottom: 3,
  },
  listLabel: {
    fontWeight: 'bold',
    width: 100,
  },
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '7.14%', // 14 columns = 100/14
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f5f5f5',
    padding: 3,
    minHeight: 25,
  },
  tableCol: {
    width: '7.14%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
    minHeight: 20,
  },
  tableColDate: {
    width: '10%',
  },
  tableColDetails: {
    width: '12%',
  },
  tableColAmount: {
    width: '6%',
  },
  tableColBalance: {
    width: '8%',
  },
  tableColPaid: {
    width: '10%',
  },
  tableCellHeader: {
    fontSize: 7,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 7,
    textAlign: 'center',
  },
  tableCellDetails: {
    fontSize: 7,
    textAlign: 'left',
  },
  tableCellAmount: {
    fontSize: 7,
    textAlign: 'center',
  },
  paidStatus: {
    fontSize: 7,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

const CashRegisterPdf = ({ data }) => {

  if (!data || !data.length) {
    return null;
  }

  return <Document>
    <Page size="A4" orientation='landscape' style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.title}>Cash Register</Text>
      </View>


      {/* Fixed Fee Section */}
      <View style={{ borderBottomWidth: 0, marginTop: 15, display: 'flex', flexDirection: 'row' }}>
        {/* <Text style={[styles.sectionTitle, { width: '17.5%', paddingTop: 2, display: 'none', borderRight: '0px solid #000', boxSizing: 'border-box' }]}>Fixed Fee</Text>
        <Text style={[styles.listLabel, { width: '30%', textAlign: 'center', paddingTop: 3, paddingBottom: 8, borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Hourly Rate</Text> */}
        <Text style={[styles.listLabel, { marginLeft: "37%", width: '32.6%', textAlign: 'center', paddingTop: 3, paddingBottom: 8, borderTop: '1px solid #000', borderLeft: '1px solid #000', borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Office Account</Text>
        <Text style={[styles.listLabel, { width: '32.6%', textAlign: 'center', paddingTop: 3, paddingBottom: 8, borderTop: '1px solid #000', borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Client Account</Text>
        <Text style={[styles.listLabel, { width: '15.2%', textAlign: 'center', paddingTop: 3, paddingBottom: 8, borderTop: '1px solid #000', borderRight: '1px solid #000', boxSizing: 'border-box' }]}>Expenses</Text>
      </View>


      {/* Ledger Table */}
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={[styles.tableColHeader, styles.tableColDate]}>
            <Text style={styles.tableCellHeader}>Date</Text>
          </View>
          <View style={[styles.tableColHeader, styles.tableColDetails]}>
            <Text style={styles.tableCellHeader}>Details</Text>
          </View>
          <View style={[styles.tableColHeader, styles.tableColDetails]}>
            <Text style={styles.tableCellHeader}>Name</Text>
          </View>
          <View style={[styles.tableColHeader, styles.tableColDetails, { width: '150px', }]}>
            <Text style={styles.tableCellHeader}>File Reference</Text>
          </View>

          {/* Office Account Columns */}
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>In</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>VAT</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Out</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>VAT</Text>
          </View>
          <View style={[styles.tableColHeader, styles.tableColBalance]}>
            <Text style={styles.tableCellHeader}>Balance</Text>
          </View>

          {/* Client Account Columns */}
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>In</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>VAT</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Out</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>VAT</Text>
          </View>
          <View style={[styles.tableColHeader, styles.tableColBalance]}>
            <Text style={styles.tableCellHeader}>Balance</Text>
          </View>

          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>{curr}+ VAT</Text>
          </View>
          <View style={[styles.tableColHeader, styles.tableColPaid]}>
            <Text style={styles.tableCellHeader}>Paid/ To Pay</Text>
          </View>
        </View>



        {/* Table Rows */}
        {data && data.map((entry, index) => {
          const dynamicBold = (entry.type === 'invoice' || (entry.debit === 0 && entry.credit === 0)) ? 'bold' : '';
          const dynamicPadding = (entry.type === 'invoice' || (entry.debit === 0 && entry.credit === 0)) ? 3 : 2;
          return <React.Fragment key={index}>
            <View style={styles.tableRow}>
              {/* Date */}
              <View style={[styles.tableCol, styles.tableColDate]}>
                <Text style={[styles.tableCell, { padding: dynamicPadding, fontWeight: dynamicBold }]}>{formatDate(entry?.date)}</Text>
              </View>

              {/* Details */}
              <View style={[styles.tableCol, styles.tableColDetails, { fontWeight: dynamicBold, padding: dynamicPadding }]}>
                <Text style={[styles.tableCellDetails, { textAlign: 'center', padding: 2 }]}>{entry?.description || ''}</Text>
                {/* <Text style={[styles.tableCellDetails, { textAlign: 'center', padding: 2 }]}>{entry?.type === "invoice" ? "Invoice" : entry?.comments || 'N/A'}</Text> */}
              </View>
              <View style={[styles.tableCol, styles.tableColDetails, { fontWeight: dynamicBold, padding: dynamicPadding }]}>
                <Text style={[styles.tableCellDetails, { textAlign: 'center', padding: 2 }]}>{entry?.name || ''}</Text>
              </View>
              <View style={[styles.tableCol, styles.tableColDetails, { width: '150px', fontWeight: dynamicBold, padding: dynamicPadding }]}>
                <Text style={[styles.tableCellDetails, { textAlign: 'center', padding: 2 }]}>AA/SK/BHAM/{entry?.file_opening_id || ''}</Text>
              </View>

              {/* Office Account */}
              <View style={styles.tableCol} >
                <Text style={[styles.tableCellAmount, { padding: 2 }]}>{entry?.credit ? curr + entry?.credit : ''}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{entry?.officeInVAT || ''}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={[styles.tableCellAmount, { padding: dynamicPadding, fontWeight: dynamicBold }]}>
                  {entry?.debit ? curr + entry?.debit : ''}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{entry?.officeOutVAT || ''}</Text>
              </View>
              <View style={[styles.tableCol, styles.tableColBalance]}>
                <Text style={[
                  styles.tableCellAmount,
                  { fontWeight: dynamicBold },
                  { padding: dynamicPadding }
                ]}>
                  {entry?.balance_amount ? curr + entry?.balance_amount : (entry.debit === 0 && entry.credit === 0) ? '' : 'NIL'}
                </Text>
              </View>

              {/* Client Account */}
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{''}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{''}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{''}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCellAmount}>{''}</Text>
              </View>
              <View style={[styles.tableCol, styles.tableColBalance]}>
                <Text style={styles.tableCellAmount}>{''}</Text>
              </View>

              {/* Additional Columns */}
              <View style={styles.tableCol}>
                <Text style={[styles.tableCellAmount, { fontWeight: 'bold', padding: 3 }]}>{(entry.debit === 0 && entry.credit === 0) ? curr + entry.amount : ''}</Text>
              </View>
              <View style={[styles.tableCol, styles.tableColPaid]}>
                <Text style={[styles.paidStatus, { padding: 3 }]}>{(entry.debit === 0 && entry.credit === 0) ? 'PAID' : ''}</Text>
              </View>
            </View>
          </React.Fragment>
        })}
      </View>

    </Page >
  </Document >
};

export default CashRegisterPdf;